import {Component, inject, Input, TemplateRef, ViewChild} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {FormControl} from "@angular/forms";
import moment from "moment";
import {CommonModule} from "@angular/common";
import {ModalWindowComponent} from "./modal-window/modal-window.component";
import {CalendarComponent} from "../components/calendar/calendar.component";
import {NewDatePipe} from "../shared/pipes/new-date.pipe";
import {MatRipple} from "@angular/material/core";
import {DateFormatPipe} from "../shared/pipes/date-format.pipe";


@Component({
  selector: 'app-date-picker',
  template: `
    <div class="date">
      <div class="date-value" *ngIf="!isHidden && !isFull">{{ controlValue | datePipe }}</div>
      <div class="date-value" *ngIf="!isHidden && isFull">{{ controlValue | dateFormat }}</div>
      <button matRipple class="action-button" [ngClass]="type" (click)="openCalendar()">
        <span class="icon-calendar"></span>
      </button>
    </div>

    <ng-template #dialogTemplate>
      <app-modal-window [title]="'Календарь'" [visible]="true" [width]="1300" [scrollbar]="false"
                        (close)="calendarRef.close()">
        <app-calendar
          [inputDate]="controlValue"
          [constructionStartDate]="constructionStartDate"
          [constructionEndDate]="constructionEndDate"
          (outputDate)="getDate($event)">
        </app-calendar>
      </app-modal-window>
    </ng-template>
  `,
  styles: [`
    @import "../shared/styles/button.style";

    .date {
      display: flex;
      align-items: center;

      &-value {
        flex: 1;
      }
    }

    .icon-calendar {
      cursor: pointer;
      font-size: 14px;
      color: #217ad8;
    }
  `],
  standalone: true,
  imports: [CommonModule, ModalWindowComponent, CalendarComponent, NewDatePipe, MatRipple, DateFormatPipe],
})
export class DatePickerComponent {
  @Input() isFull = false;
  @Input() control: FormControl | any;
  @Input() isHidden = false;
  dialog = inject(MatDialog);
  
  @ViewChild('dialogTemplate') dialogTemplate!: TemplateRef<any>;
  @Input() type: 'small' | 'big' = 'big';

  private _constructionStartDate: number;
  private _constructionEndDate: number;

  @Input()
  set constructionStartDate(value: string) {
    this._constructionStartDate = new Date(value).getTime();
  }

  get constructionStartDate(): number {
    return this._constructionStartDate;
  }

  @Input()
  set constructionEndDate(value: string) {
    this._constructionEndDate = new Date(value).getTime();
  }

  get constructionEndDate(): number {
    return this._constructionEndDate;
  }

  get controlValue(): number | null {
    const value = this.control.value;
    return value ? moment(value, 'YYYY-MM-DD').valueOf() : null;
  }


  calendarRef: any;
  openCalendar() {
    this.calendarRef = this.dialog.open(this.dialogTemplate, {
      width: '1300px',
      maxWidth: '1300px'
    });
  }

  getDate(date: number) {
    this.control.setValue(moment(date).format('YYYY-MM-DD'));
    this.control.markAsDirty();
    // this.dialog.closeAll();
    this.calendarRef?.close();
    this.calendarRef = undefined;
  }

}
